/* Kunst van Staal · gedrag van de collectiepagina (templates collection.interieur en collection.tuin).
   Filteren, sorteren en meer laden via de Section Rendering API: geen pagina-refresh,
   de URL blijft deelbaar. Plus de filterlade, de zwevende filterknop en "Lees meer". */
(function () {
  if (window.__kvsCollection) return;
  window.__kvsCollection = true;

  function initCards(root) { if (window.kvsInitCards) window.kvsInitCards(root); }

  /* ---------- Producten + filters ---------- */
  function initPlp(sec) {
    if (sec.dataset.kvsPlpInit) return; sec.dataset.kvsPlpInit = 1;
    var id = sec.getAttribute('data-kvs-plp-section');
    var drawer = sec.querySelector('[data-kvs-drawer]');
    var busy = null, timer = null;

    /* Parameters die we altijd meenemen (bijv. ?view= tijdens het testen van een template) */
    function keepParams(params) {
      var cur = new URLSearchParams(location.search);
      if (cur.get('view') && !params.has('view')) params.set('view', cur.get('view'));
      return params;
    }
    function paramsFromForm(form) {
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return keepParams(p);
    }
    function sectionUrl(url) {
      var u = new URL(url, location.origin);
      u.searchParams.set('section_id', id);
      return u.toString();
    }

    /* ---------- Meer laden ---------- */
    function shownCards() {
      return [].filter.call(sec.querySelectorAll('[data-kvs-grid] > .pdp-related__card'), function (c) { return c.getClientRects().length > 0; });
    }
    /* Kaarten die nog verborgen zijn. Komt er nog een pagina (collectie > 250), dan wachten uitverkochte tot die binnen is,
       zodat ze ook over de paginagrens heen achteraan blijven. */
    function waitingCards() {
      var grid = sec.querySelector('[data-kvs-grid]');
      var holdSold = grid && grid.hasAttribute('data-soldout-last') && sec.querySelector('[data-kvs-next]');
      return [].filter.call(sec.querySelectorAll('[data-kvs-grid] > [data-kvs-more-item][hidden]'), function (c) {
        return c.getClientRects().length === 0 && !(holdSold && c.classList.contains('is-soldout'));
      });
    }
    function syncMore() {
      var more = sec.querySelector('[data-kvs-more]'); if (!more) return;
      var total = +more.getAttribute('data-total') || 0, seen = shownCards().length;
      var seenEl = more.querySelector('[data-kvs-seen]'); if (seenEl) seenEl.textContent = seen;
      var bar = more.querySelector('[data-kvs-bar]'); if (bar && total) bar.style.width = Math.min(100, Math.round(seen * 100 / total)) + '%';
      var left = waitingCards().length > 0, nx = more.querySelector('[data-kvs-next]'), rv = more.querySelector('[data-kvs-reveal]');
      if (rv) rv.hidden = !left;
      if (nx) nx.hidden = left;
      more.hidden = !left && !nx;
    }

    /* Focus terugzetten na het verversen: zelfde vakje in dezelfde kolom of lade */
    function focusKey() {
      var el = document.activeElement;
      if (!el || !sec.contains(el)) return null;
      var box = el.closest('[data-kvs-drawer]') ? '[data-kvs-drawer] ' : '[data-kvs-side] ';
      if (el.matches('[data-kvs-sort]')) return '[data-kvs-sort]';
      if (el.matches('[data-kvs-bucket]')) return box + '[data-kvs-bucket][data-min="' + el.getAttribute('data-min') + '"]';
      if (el.name) return box + '[name="' + CSS.escape(el.name) + '"]' + (el.type === 'checkbox' ? '[value="' + CSS.escape(el.value) + '"]' : '');
      return null;
    }

    function load(url, opts) {
      opts = opts || {};
      var plp = sec.querySelector('[data-kvs-plp]');
      if (plp) plp.classList.add('is-loading');
      if (busy) busy.abort();
      busy = 'AbortController' in window ? new AbortController() : null;
      return fetch(sectionUrl(url), busy ? { signal: busy.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-kvs-plp]');
          if (!fresh) { location.href = url; return; }
          if (opts.append) {
            /* Volgende pagina: alleen de nieuwe kaarten erbij (de promotegel niet opnieuw).
               Beschikbare kaarten gaan vóór de uitverkochte van de vorige pagina, zodat uitverkocht achteraan blijft. */
            var grid = sec.querySelector('[data-kvs-grid]'), sold = grid.hasAttribute('data-soldout-last') && grid.querySelector(':scope > .pdp-related__card.is-soldout');
            fresh.querySelectorAll('[data-kvs-grid] > .pdp-related__card').forEach(function (card) {
              card.removeAttribute('data-kvs-fill');
              if (sold && !card.classList.contains('is-soldout')) grid.insertBefore(card, sold); else grid.appendChild(card);
            });
            var nx = sec.querySelector('[data-kvs-next]'), freshNx = fresh.querySelector('[data-kvs-next]');
            if (nx) { if (freshNx) nx.replaceWith(freshNx); else nx.remove(); }
            plp.classList.remove('is-loading');
            syncMore();
            initCards(sec);
            return;
          }
          var fk = focusKey(), oldCount = sec.querySelector('[data-kvs-count]');
          plp.replaceWith(fresh);
          /* Aantal: dezelfde node houden en alleen de tekst wijzigen, zodat schermlezers het nieuwe aantal voorlezen */
          var newCount = sec.querySelector('[data-kvs-count]');
          if (oldCount && newCount) { oldCount.textContent = newCount.textContent; newCount.replaceWith(oldCount); }
          /* Lade: alleen de inhoud vervangen, zodat hij open blijft tijdens het filteren */
          var dForm = drawer && drawer.querySelector('[data-kvs-filters]');
          var fDrawer = doc.querySelector('[data-kvs-drawer] [data-kvs-filters]');
          if (dForm && fDrawer) dForm.innerHTML = fDrawer.innerHTML;
          ['[data-kvs-drawer-count]', '[data-kvs-fab]'].forEach(function (sel) {
            var a = sec.querySelector(sel), b = doc.querySelector(sel);
            if (a && b) a.innerHTML = b.innerHTML;
          });
          var foot = drawer && drawer.querySelector('.kvs-fdrawer__foot .kvs-btn--ghost'), fFoot = doc.querySelector('.kvs-fdrawer__foot .kvs-btn--ghost');
          if (foot && fFoot) foot.setAttribute('href', fFoot.getAttribute('href'));
          var clean = new URL(url, location.origin); clean.searchParams.delete('section_id'); clean.searchParams.delete('page');
          history.replaceState(null, '', clean.pathname + clean.search);
          initCards(sec);
          syncMore();
          watchToolbar();
          if (fk) { var f = sec.querySelector(fk); if (f) f.focus({ preventScroll: true }); }
          if (opts.scroll) {
            var top = sec.querySelector('[data-kvs-plp]').getBoundingClientRect().top + window.scrollY - headerBottom() - 12;
            if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
          }
        })
        .catch(function (e) { if (!e || e.name !== 'AbortError') location.href = url; });
    }

    /* Wijziging in een filterformulier (kolom of lade) */
    sec.addEventListener('change', function (e) {
      var form = e.target.closest('[data-kvs-filters]');
      if (form && e.target.matches('[data-kvs-bucket]')) {
        /* Prijsvakjes: één tegelijk; zet de verborgen van/tot-velden die Shopify kent */
        var fs = e.target.closest('fieldset');
        fs.querySelectorAll('[data-kvs-bucket]').forEach(function (b) { if (b !== e.target) b.checked = false; });
        var on = e.target.checked;
        fs.querySelector('[data-kvs-pmin]').value = on ? e.target.getAttribute('data-min') : '';
        fs.querySelector('[data-kvs-pmax]').value = on ? e.target.getAttribute('data-max') : '';
      }
      if (form) {
        clearTimeout(timer);
        var delay = e.target.type === 'number' ? 500 : 0;
        timer = setTimeout(function () {
          var params = paramsFromForm(form);
          load(location.pathname + '?' + params.toString(), { scroll: !drawer || drawer.hidden });
        }, delay);
        return;
      }
      if (e.target.matches('[data-kvs-sort]')) {
        var p = new URLSearchParams(location.search);
        p.set('sort_by', e.target.value); p.delete('page');
        load(location.pathname + '?' + p.toString());
      }
    });
    /* Prijsvelden: ook filteren na typen (zonder blur) */
    sec.addEventListener('input', function (e) {
      if (e.target.type !== 'number' || !e.target.closest('[data-kvs-filters]')) return;
      clearTimeout(timer);
      var form = e.target.closest('[data-kvs-filters]');
      timer = setTimeout(function () { load(location.pathname + '?' + paramsFromForm(form).toString()); }, 800);
    });

    /* Chips, "Wis alles" en meer laden */
    sec.addEventListener('click', function (e) {
      var link = e.target.closest('[data-kvs-link]');
      if (link) { if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return; e.preventDefault(); var u = new URL(link.href, location.origin); keepParams(u.searchParams); load(u.pathname + u.search, { scroll: true }); return; }
      var reveal = e.target.closest('[data-kvs-reveal]');
      if (reveal) {
        /* Volgende kaarten tonen; die staan al op de pagina. De mobiele vulkaart was al zichtbaar en telt niet mee. */
        var more = sec.querySelector('[data-kvs-more]'), step = +more.getAttribute('data-step') || 24;
        sec.querySelectorAll('[data-kvs-grid] > [data-kvs-fill]').forEach(function (c) { if (c.getClientRects().length) c.hidden = false; c.removeAttribute('data-kvs-fill'); });
        waitingCards().slice(0, step).forEach(function (c) { c.hidden = false; });
        syncMore();
        initCards(sec);
        if (reveal.hidden) { var nf = sec.querySelector('[data-kvs-next]:not([hidden])'); if (nf) nf.focus({ preventScroll: true }); }
        return;
      }
      var next = e.target.closest('[data-kvs-next]');
      if (next) { if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return; e.preventDefault(); var n = new URL(next.href, location.origin); keepParams(n.searchParams); next.textContent = 'Laden…'; load(n.pathname + n.search, { append: true }); return; }
      if (e.target.closest('[data-kvs-filter-open]')) { openDrawer(); return; }
      if (e.target.closest('[data-kvs-drawer-close]')) { closeDrawer(); }
    });

    /* ---------- Lade ---------- */
    var lastFocus = null, hideTimer = 0;
    function setExpanded(on) { sec.querySelectorAll('[data-kvs-filter-open]').forEach(function (b) { b.setAttribute('aria-expanded', on ? 'true' : 'false'); }); }
    var lockY = 0;
    function openDrawer() {
      if (!drawer) return;
      clearTimeout(hideTimer);
      lastFocus = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      /* iOS: de pagina erachter vastzetten, anders scrolt die mee, klapt de browserbalk in en valt er onder de lade een strook open */
      lockY = window.scrollY;
      document.body.style.position = 'fixed'; document.body.style.top = -lockY + 'px'; document.body.style.left = '0'; document.body.style.right = '0';
      setExpanded(true);
      var x = drawer.querySelector('.kvs-fdrawer__x'); if (x) x.focus();
    }
    function closeDrawer() {
      if (!drawer || drawer.hidden || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (document.body.style.position === 'fixed') {
        document.body.style.position = ''; document.body.style.top = ''; document.body.style.left = ''; document.body.style.right = '';
        window.scrollTo(0, lockY);
      }
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { drawer.hidden = true; }, 380);
      setExpanded(false);
      /* De knop kan intussen vervangen zijn door het filteren */
      var back = lastFocus && lastFocus.isConnected ? lastFocus : sec.querySelector('[data-kvs-filter-open]');
      if (back) back.focus({ preventScroll: true });
    }
    document.addEventListener('keydown', function (e) {
      if (!drawer || drawer.hidden) return;
      if (e.key === 'Escape') { closeDrawer(); return; }
      /* Tab blijft binnen de open lade */
      if (e.key !== 'Tab') return;
      var f = [].filter.call(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (el) { return !el.disabled && el.getClientRects().length; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
    });

    /* ---------- Plakhoogte van de header (voor de filterkolom) ---------- */

    /* ---------- Zwevende filterknop: alleen als de balk uit beeld is en je in de producten zit ---------- */
    var fab = sec.querySelector('[data-kvs-fab]'), io = null;
    function watchToolbar() {
      if (!fab || !('IntersectionObserver' in window)) return;
      if (io) io.disconnect();
      var bar = sec.querySelector('.kvs-plp__toolbar'), grid = sec.querySelector('[data-kvs-grid]');
      var barOut = false, inGrid = false;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === bar) barOut = !en.isIntersecting && en.boundingClientRect.top < 0;
          if (en.target === grid) inGrid = en.isIntersecting;
        });
        fab.classList.toggle('is-on', barOut && inGrid);
      });
      if (bar) io.observe(bar);
      if (grid) io.observe(grid);
    }
    watchToolbar();
    syncMore();
  }

  /* ---------- Hoogte van de plakkende header (voor de filterkolom en de FAQ die meeschuiven) ---------- */
  function headerBottom() {
    var h = document.querySelector('.t4s-section-header, header.t4s-header, sticky-header, .header-wrapper');
    if (!h) return 0;
    var cs = getComputedStyle(h), r = h.getBoundingClientRect();
    return (cs.position === 'sticky' || cs.position === 'fixed') && r.top <= 1 ? Math.round(r.bottom) : 0;
  }
  var stickyRaf = 0, stickyOn = false;
  function setStickyTop() {
    if (document.querySelector('[data-kh]')) return; /* KvS-header zet --kvs-sticky-top zelf (assets/kvs-header.js) */
    document.documentElement.style.setProperty('--kvs-sticky-top', headerBottom() + 'px');
  }
  function initSticky() {
    if (stickyOn || !document.querySelector('.kvs-aboutsec--sticky')) return;
    stickyOn = true;
    window.addEventListener('scroll', function () { if (!stickyRaf) stickyRaf = requestAnimationFrame(function () { stickyRaf = 0; setStickyTop(); }); }, { passive: true });
    setStickyTop();
  }

  /* ---------- Lees meer ---------- */
  function initReadmore(root) {
    root.querySelectorAll('[data-kvs-readmore]').forEach(function (body) {
      if (body.dataset.kvsRmInit) return; body.dataset.kvsRmInit = 1;
      var btn = body.parentElement.querySelector('[data-kvs-readmore-btn]');
      if (!btn) return;
      var label = btn.querySelector('[data-kvs-readmore-label]') || btn, more = label.textContent;
      body.classList.add('is-clamped');
      if (body.scrollHeight > body.clientHeight + 8) btn.hidden = false; else body.classList.remove('is-clamped');
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('is-clamped') === false;
        label.textContent = open ? 'Lees minder' : more;
        btn.setAttribute('aria-expanded', open);
        if (!open) { var top = body.closest('.kvs-about').getBoundingClientRect().top + window.scrollY - 120; if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' }); }
      });
    });
  }

  /* ---------- Intro in de compacte banner: rest openklappen ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-kvs-intro-more]');
    if (!btn) return;
    var rest = document.getElementById(btn.getAttribute('aria-controls'));
    if (!rest) return;
    var open = rest.hidden;
    rest.hidden = !open;
    btn.setAttribute('aria-expanded', open);
    btn.textContent = open ? 'Minder' : 'Lees meer';
  });

  function init(root) {
    root = root || document;
    root.querySelectorAll('[data-kvs-plp-section]').forEach(initPlp);
    if (root.matches && root.matches('[data-kvs-plp-section]')) initPlp(root);
    initReadmore(root);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
